var React = require('react');

function IconChart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.25 21v-9h-6v9h-3V9h-6v12H3V1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21h-2.25zm-10.5 0h-3V10.5h3V21zm9 0h-3v-7.5h3V21z","key":0}),React.createElement("path",{"d":"M17.09 10.5c-.32 0-.63-.1-.89-.29L8.4 4.49 6.18 7.5l-1.2-.9 2.23-3a1.5 1.5 0 012.07-.33L17.09 9l2.7-3.64 1.21.89-2.7 3.64a1.5 1.5 0 01-1.21.61z","key":1})]);
}

IconChart.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChart;

IconChart.default = IconChart;
